import { globalStyle, style, styleVariants } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'
import { SubmitAlignment } from './SubmitAlignment'

export const globalError = style({
  color: vars.color.danger,
  fontSize: 16,
  fontWeight: 500
})

export const globalErrorSpacer = style({
  height: 20
})

export const formClassLarge = style({
  gap: 32
})

export const formClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 18,

  selectors: {
    [`${formClassLarge} &`]: {
      gap: 24
    }
  }
})

export const inputLine = style({
  display: 'flex',
  gap: 16,
  justifyContent: 'space-between'
})

export const inputLineCompact = style({
  width: 'fit-content'
})

export const inputLineJustifyStart = style({
  justifyContent: 'flex-start'
})

export const inputLineJustifyEnd = style({
  justifyContent: 'flex-end'
})

export const inputLineCenter = style({
  alignItems: 'center'
})

export const inputGroup = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 8
})

export const submitWrapper = style({
  display: 'flex'
})

export const submitAlignments = styleVariants({
  [SubmitAlignment.Left]: {
    justifyContent: 'flex-start'
  },
  [SubmitAlignment.Center]: {
    justifyContent: 'center'
  },
  [SubmitAlignment.Right]: {
    justifyContent: 'flex-end'
  }
})

export const fieldset = style({
  display: 'none',
  flexDirection: 'column',
  gap: 16,
  marginTop: 16,
  marginBottom: 8,
  padding: 15,
  background: vars.color.light,
  border: `1px solid ${vars.color.mediumLighter}`,
  borderRadius: vars.buttons.radius
})

export const fieldsetOpen = style({
  display: 'flex'
})

globalStyle(
  `${inputLine}:not(${inputLineJustifyStart}):not(${inputLineJustifyEnd}) > *`,
  {
    flex: 1
  }
)
